<div class="mat-body">
    <button type="button" class="btn-close mat-elevation-z0" mat-icon-button (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>

    <h2 class="mat-headline">{{ 'dialog.can-not-add-participant.add'|translate }}</h2>
    <p [innerHTML]="errorMsg|translate"></p>
    <p [innerHTML]="'dialog.can-not-add-participant.can-add-other'|translate"></p>
    <p class="mb-4" [innerHTML]="'dialog.can-not-add-participant.sorry-inconvenience'|translate"></p>

    <div class="row align-items-center">
        <div class="col-12 col-sm-6">
            <h3 class="mat-display-2 text-blue font-weight-bold mb-0" [innerHTML]="'dialog.phone.phones'|translate"></h3>
        </div>
        <div class="col-12 col-sm-6">
            <p class="hours mb-0" [innerHTML]="'dialog.phone.hours'|translate"></p>
        </div>
    </div>
</div>
